import { useEffect, useState } from "react";
import { useQuestionizerStore } from "../types/state.ts";
import { FDWAntragsteller, FDWResultEntry } from "../../../restfd2/fdw_result.ts";
import Checkbox from "./checkbox.tsx";
import LoadingIndicator from "./loading-indicator.tsx";
import Input from "./input.tsx";
import { DoiForm, LeadForm } from "./lead_form.tsx";

export default function QuestionizerResult(props: {id: number}){
    const result = useQuestionizerStore((state) => state.result);
    const session_id = useQuestionizerStore((state) => state.session_id);
    const gemeinde_id = useQuestionizerStore((state) => state.gemeinde_id);
    const gewerk = useQuestionizerStore((state) => state.gewerk);
    const gebaeude = useQuestionizerStore((state) => state.gebaeude);
    const typ = useQuestionizerStore((state) => state.typ);
    const baujahr = useQuestionizerStore((state) => state.baujahr);
    const wohngebaeude = useQuestionizerStore((state) => state.wohngebaeude);
    const gewerbegebaude = useQuestionizerStore((state) => state.gewerbegebaeude);
    const gemeinnuetzig = useQuestionizerStore((state) => state.gemeinnuetzig);
    const requestResult = useQuestionizerStore((state) => state.requestResult);
    const antragsteller = useQuestionizerStore((state) => state.antragsteller);
    const antragsteller_detail = useQuestionizerStore((state) => state.antragsteller_detail);
    const lead_sended = useQuestionizerStore((state) => state.lead_sended);
    const doi_confirm = useQuestionizerStore((state) => state.doi_confirm);
    const hide_results_until_confirmation = useQuestionizerStore((state) => state.config?.hide_results_until_confirmation);
    const show_lead_form = useQuestionizerStore((state) => state.config?.show_lead_form);

    useEffect(()=>{
      requestResult();
   },[session_id, gebaeude, typ, baujahr, wohngebaeude, gewerbegebaude, gemeinnuetzig, gemeinde_id, gewerk, antragsteller_detail, antragsteller]);

    if (session_id == undefined || result == undefined){
      return <div className={"col-span-12 input-"+props.id}><LoadingIndicator /></div>
    }

    if(hide_results_until_confirmation){
      return (<div className={"col-span-12 input-"+props.id}>
        <QuestionizerResultSummary />
        <QuestionizerResultTeaser />
        <DoiForm/>
        {show_lead_form && <LeadForm/>}
        {doi_confirm && <QuestionizerResultTabs/>}
      </div>);  
    }
    
    return (<div className={"col-span-12 input-"+props.id}>
      <QuestionizerResultSummary />
      <QuestionizerResultTabs/>
    </div>);  
  }

  function QuestionizerResultSummary(){
    const plz = useQuestionizerStore((state) => state.plz);
    const gemeinde = useQuestionizerStore((state) => state.gemeinde);
    const gewerk_labels = useQuestionizerStore((state) => state.getGewerkLabels());
    const gebaeude = useQuestionizerStore((state) => state.gebaeude);
    const typ = useQuestionizerStore((state) => state.typ);
    const baujahr = useQuestionizerStore((state) => state.baujahr);
    const antragsteller = useQuestionizerStore((state) => state.antragsteller);
    const antragsteller_detail = useQuestionizerStore((state) => state.antragsteller_detail);
    const _antragsteller = (antragsteller?.length == 1) ? antragsteller[0] : antragsteller_detail;

    //console.log("LABELS:",gewerk_labels);
    
    return (<div className="mb-8">
        <p className="mb-8">Die Programminfos zu den ausgewählten Förderungen können direkt online eingesehen oder nach Auswahl gespeichert und ausgedruckt werden.</p>
        <section role="grid" className="summary">
          <h2  className="summary__title">Ihre Angaben</h2>
          <div role="row"><span role="cell" className="summary__bullet">Gewählte Maßnahmen</span>: <span role="cell">{gewerk_labels.join(', ')}</span></div>
          <div role="row"><span role="cell" className="summary__bullet">Antragsteller</span>: <span role="cell">{FDWAntragsteller[_antragsteller!]}</span></div>
          {/* <div><span className="summary__bullet">PLZ</span>: <span>{plz}</span></div> */}
          <div role="row"><span role="cell" className="summary__bullet">Ort</span>: <span role="cell">{plz} {gemeinde?.gemeinde_name}</span></div>
          <div><span role="cell" className="summary__bullet">Gebäude</span>: <span role="cell">{gebaeude}</span></div>
          <div role="row"><span role="cell" className="summary__bullet">Typ</span>: <span role="cell">{typ}</span></div>
          <div role="row"><span role="cell" className="summary__bullet">Baujahr</span>: <span role="cell">{baujahr}</span></div>
        </section>
    </div>);  
  }

  function QuestionizerResultTeaser(){
    const include_all_results_in_print = useQuestionizerStore((state) => state.config?.include_all_results_in_print || false);
    const include_in_print = useQuestionizerStore((state) => state.include_in_print);
    const setIncludeInPrint = useQuestionizerStore((state) => state.setIncludeInPrint);
    const [active_tab, set_active_tab] = useState<"zuschusse" | "darlehen">("zuschusse");
    const result = useQuestionizerStore((state) => state.result);
    const initialSelectAll =  include_all_results_in_print || false;
    const [select_all, setSelectAll] = useState(initialSelectAll); 

    type SortedResultsList = Record<string,{region: string, list: Array<FDWResultEntry>}>;

    if (result == undefined){
      return <div></div>
    }
  
    const zuschuesse = result.filter((entry) => entry.fp_type == "Zuschuss").reduce((acc: SortedResultsList, entry : FDWResultEntry)=>{
      if (!acc[entry.region]){
        acc[entry.region] = {region:entry.region, list: [entry]}; 
      }else{
        acc[entry.region].list.push(entry);
      }
      return acc;
    },{});

    const darlehen = result.filter((entry) => entry.fp_type == "Darlehen").reduce((acc : SortedResultsList, entry : FDWResultEntry)=>{
      if (!acc[entry.region]){
        acc[entry.region] = {region:entry.region, list: [entry]}; 
      }else{
        acc[entry.region].list.push(entry);
      }
      return acc;
    },{});

	// Zuschüsse & Darlehen zusammenführen
	let all_zuschuesse = Object.keys(zuschuesse).flatMap(key => zuschuesse[key].list);
	let all_darlehen = Object.keys(darlehen).flatMap(key => darlehen[key].list);
	let all_programme = [...all_zuschuesse, ...all_darlehen];

	let zuschuesse_length = all_zuschuesse.length;
	let darlehen_length = all_darlehen.length;

	let bundesprogramme_length = all_programme.filter(z => z.region === "Bundesweit verfügbare Programme").length;
	let landesprogramme_length = all_programme.filter(z => z.region === "Im Bundesland verfügbare Programme").length;
	let gemeindeprogramme_length = all_programme.filter(z => z.region === "In der Gemeinde verfügbare Programme").length;


    return (<div className="mb-8 text-center">
            <p className="text-xl">{`Wir haben für Sie ${zuschuesse_length} passende Zuschuss- und  ${darlehen_length} Darlehen-Förderprogramme auf Bundes-, Landes- und kommunaler Ebene recherchiert:`}</p>
			<div className="text-xl font-bold">{bundesprogramme_length} Bundesprogramme</div>
			<div className="text-xl font-bold">{landesprogramme_length} Landesprogramme</div>
			<div className="text-xl font-bold">{gemeindeprogramme_length} kommunale Programme</div>
    </div>); 
  }



  function QuestionizerResultTabs(){
	const include_all_results_in_print = useQuestionizerStore((state) => state.config?.include_all_results_in_print || false);
	const include_in_print = useQuestionizerStore((state) => state.include_in_print);
    const setIncludeInPrint = useQuestionizerStore((state) => state.setIncludeInPrint);
    const [active_tab, set_active_tab] = useState<"zuschusse" | "darlehen">("zuschusse");
    const result = useQuestionizerStore((state) => state.result);
    const initialSelectAll =  include_all_results_in_print || false;
    const [select_all, setSelectAll] = useState(initialSelectAll); 

    type SortedResultsList = Record<string,{region: string, list: Array<FDWResultEntry>}>;

    if (result == undefined){
      return <div></div>
    }
	const sortedData = [...result].sort((a, b) => Number(a.fp_id) - Number(b.fp_id));
    const zuschuesse = sortedData.filter((entry) => entry.fp_type == "Zuschuss").reduce((acc: SortedResultsList, entry : FDWResultEntry)=>{
      if (!acc[entry.region]){
        acc[entry.region] = {region:entry.region, list: [entry]}; 
      }else{
        acc[entry.region].list.push(entry);
      }
      return acc;
    },{});

    const darlehen = sortedData.filter((entry) => entry.fp_type == "Darlehen").reduce((acc : SortedResultsList, entry : FDWResultEntry)=>{
      if (!acc[entry.region]){
        acc[entry.region] = {region:entry.region, list: [entry]}; 
      }else{
        acc[entry.region].list.push(entry);
      }
      return acc;
    },{});

    let zuschuesse_length = Object.keys(zuschuesse).flatMap(key => zuschuesse[key].list).length;
    let darlehen_length = Object.keys(darlehen).flatMap(key => darlehen[key].list).length;

    return (<div role="select" className="tabs">
          <div className="tabs__header">
            <Tab label="Zuschüsse" value="zuschusse" count={zuschuesse_length} active_tab={active_tab} set_active_tab={set_active_tab}/>
            <Tab label="Darlehen" value="darlehen" count={darlehen_length} active_tab={active_tab} set_active_tab={set_active_tab}/>
          </div>
		
			<div className="flex flex-row"> 
			  {(zuschuesse_length > 0 || darlehen_length > 0) ? (
				<>
				  <Checkbox value={select_all} onChange={(value)=>{
					setSelectAll(value);
					Object.keys(include_in_print).forEach((key) => {
					  setIncludeInPrint(Number(key), value);
					});
				  }}/>
				  <p className="mt-[0.5rem]">alle auswählen</p>
				</>
			  ) : (
				  <p className="mt-[0.5rem] text-gray-500">Leider gibt es für Ihre Auswahl aktuell keine passenden Förderprogramme.</p>
			  )}
			</div>
		
          <div className="tabs__body">
            <QuestionizerAccordion active={active_tab == "zuschusse"}  regions={zuschuesse} />
            <QuestionizerAccordion active={active_tab == "darlehen"} regions={darlehen} />
          </div>
    </div>);  
  }

	function QuestionizerAccordion(props: {
	  active: boolean,
	  regions: Record<string, { region: string, list: Array<FDWResultEntry> }>
	}) {
		const [activeElements, setActiveElements] = useState<Set<string>>(() => {
		  const firstKey = Object.keys(props.regions)[0];
		  return new Set([firstKey]); // Set mit dem ersten Key
		});

	  const toggleElement = (key: string) => {
		setActiveElements(prev => {
		  const newSet = new Set(prev);
		  newSet.has(key) ? newSet.delete(key) : newSet.add(key);
		  return newSet;
		});
	  };

	  return (
		<div className="accordion">
		  {props.active && Object.keys(props.regions).map((key: string) => {
			const region = props.regions[key];
			const isActive = activeElements.has(key);

			return (
			  <div className="accordion__element" key={key}>
				<h3 className="accordion__element_title" 
        tabIndex={0} 
        onClick={() => toggleElement(key)}
        onKeyUp={(event) => {
          if(event.code != "Enter" && event.code != " "){return;}
          toggleElement(key)
        }}
        >
				  <div className={`icon accordion__element_icon ${isActive ? "accordion__element_icon--active" : ""}`} />
				  <span>{region.region} ({region.list.length})</span>
				</h3>
				{isActive && region.list.map((entry: FDWResultEntry) =>
				  <QuestionizerResultItem key={entry.fp_id} entry={entry} />
				)}
			  </div>
			);
		  })}
		</div>
	  );
	}

  function QuestionizerResultItem(props:{entry:FDWResultEntry}){
    const include_in_print = useQuestionizerStore((state) => state.include_in_print);
    const setIncludeInPrint = useQuestionizerStore((state) => state.setIncludeInPrint);
    //const setIncludeInPrintExclusive = useQuestionizerStore((state) => state.setIncludeInPrintExclusive);

    const openPrintView = useQuestionizerStore((state) => state.openPrintView);

    return (<div className="result-item flex flex-row items-start mb-4 cursor-pointer">
        <Checkbox value={include_in_print[props.entry.fp_id]} onChange={(value)=>{setIncludeInPrint(props.entry.fp_id, value)}}/>
        <div className="mr-4 flex flex-col items-start">
          <span className="result-item__name font-bold">{props.entry.fp_name}</span>
          <span className="result-item__betrag">{props.entry.fp_betrag}</span>
        </div>
        <span tabIndex={0} aria-label="Als PDF-Dokument anzeigen" className={"result-item__print"} 
          onClick={(_)=>{
            openPrintView(props.entry.fp_id);
          }}
          onKeyUp={(event)=>{
            if(event.code != "Enter" && event.code != " "){return;}
            openPrintView(props.entry.fp_id);
          }}
          >
            <span aria-hidden className="result-item__print_label">Anzeigen</span><div className={"icon icon-print result-item__icon_print"}></div></span>
    </div>);  
  }

function Tab(props:{value: "zuschusse" | "darlehen", label: string, count:number, active_tab: "zuschusse" | "darlehen", set_active_tab: (string) => void}){
  const is_active = props.value == props.active_tab;
    return <div
        role="option" 
        tabIndex={0} 
        className={"tabs__header_item " + (props.count == 0 ? " tabs__header_item--empty ": "") + (is_active ? "tabs__header_item--active" : "")} 
        aria-selected={is_active} 
        onClick={()=>{props.set_active_tab(props.value)}}
        onKeyUp={(event)=>{
          if(event.code != "Enter" && event.code != " "){return;}
          props.set_active_tab(props.value)
        }}
      >
      {props.label} ({props.count})
    </div>
  }